import { BuildData, KnightKey, NimueSelection } from '../types';

export const constructBuildData = (
    name: string,
    knight: KnightKey,
    weapon: string,
    spell: string,
    blessings: Set<string>,
    nimueSelection?: NimueSelection,
    anvilData?: { mode: 'single' | 'double'; upgrades: string[] },
    morganaData?: { mode: 'single' | 'double'; modifiers: string[] },
    merlinData?: { mode: 'single' | 'double'; upgrades: string[] },
    sourceData?: { [key: string]: 'A' | 'B' }
): Omit<BuildData, 'id' | 'createdAt' | 'updatedAt'> => {
  return {
    name,
    knight,
    weapon,
    spell,
    blessings: Array.from(blessings),
    nimue: nimueSelection || { option1: null, option2: null },
    anvil: anvilData,
    morgana: morganaData,
    merlin: merlinData,
    source: sourceData,
  };
};

export const isValidBuildData = (data: unknown): data is Omit<BuildData, 'id' | 'createdAt' | 'updatedAt'> => {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;
  return (
    typeof d.name === 'string' &&
    typeof d.knight === 'string' &&
    typeof d.weapon === 'string' &&
    typeof d.spell === 'string' &&
    Array.isArray(d.blessings)
  );
};

export const countOccurrences = (list: string[]) => {
  return list.reduce((acc, curr) => {
    acc[curr] = (acc[curr] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);
};
